import { render } from "./App.vue?vue&type=template&id=532f2426"
const script = {}

import "./App.vue?vue&type=style&index=0&id=532f2426&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__